import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage, useIntl } from 'react-intl';
import { default as isMobile } from '../../../common/IsMobile';
import { formatDeliveryEstimation } from '../../../resources/delivery-estimation-formatter/deliveryEstimationFormatter';
import { hasDuration } from '../../../resources/deliveryEstimationService';
import componentStyles from './SpeedContent.module.less';
const SpeedContent = ({ deliveryEstimation, isFeaturedRow = false, }) => {
    return hasDuration(deliveryEstimation)
        ? availableElement(isFeaturedRow, deliveryEstimation)
        : unavailableElement(isFeaturedRow);
};
const availableElement = (isFeaturedRow, deliveryEstimation) => {
    const { locale } = useIntl();
    return isMobile()
        ? mobileSpeedElement(isFeaturedRow, locale, deliveryEstimation)
        : desktopSpeedElement(isFeaturedRow, locale, deliveryEstimation);
};
const speedStyle = (isFeaturedRow) => `${componentStyles.speed} ${isFeaturedRow ? componentStyles.speedDark : ''}`;
const speedUnavailableStyle = (isFeaturedRow) => `${componentStyles.speed__unavailable} ${isFeaturedRow ? componentStyles.speed__unavailableDark : ''}`;
const mobileSpeedElement = (isFeaturedRow, locale, deliveryEstimation) => {
    const speedText = formatDeliveryEstimation(deliveryEstimation, { lang: locale }, { showAsBusiness: true, includePrefix: true, isSpeedFormat: true });
    return (_jsx("div", Object.assign({ className: speedStyle(isFeaturedRow) }, { children: _jsx(FormattedMessage, { id: "should-arrive", values: {
                speed: speedText,
                span: (chunks) => (_jsx("span", Object.assign({ className: componentStyles.speed__durationText }, { children: chunks }))),
            } }) })));
};
const desktopSpeedElement = (isFeaturedRow, locale, deliveryEstimation) => {
    const speedText = formatDeliveryEstimation(deliveryEstimation, { lang: locale }, { showAsBusiness: true, includePrefix: false, isSpeedFormat: true });
    return (_jsx("div", Object.assign({ className: speedStyle(isFeaturedRow) }, { children: _jsxs("span", { children: [" ", speedText, " "] }) })));
};
const unavailableElement = (isFeaturedRow) => {
    const messageId = isMobile() ? 'speed-unavailable' : 'unavailable';
    return (_jsx("div", Object.assign({ className: speedUnavailableStyle(isFeaturedRow) }, { children: _jsx(FormattedMessage, { id: messageId }) })));
};
export default SpeedContent;
